var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPreview = function SvgPreview(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9999 16C30.8757 16 30.7599 16.0314 30.6373 16.0364C33.5626 18.3725 34.7234 22.2832 33.5464 25.8369C32.3694 29.3907 29.1037 31.8354 25.3623 31.9634C28.4331 34.451 32.7689 34.6396 36.044 32.4281C39.3192 30.2165 40.7644 26.1243 39.6044 22.3465C38.4445 18.5686 34.9518 15.9925 30.9999 16Z",
    fill: "#FFE0E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10H31C31.5523 10 32 9.55228 32 9C32 8.44772 31.5523 8 31 8H3C2.44772 8 2 8.44772 2 9C2 9.55228 2.44772 10 3 10Z",
    fill: "#FC628F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40H3C2.44772 40 2 40.4477 2 41C2 41.5523 2.44772 42 3 42H31C31.5523 42 32 41.5523 32 41C32 40.4477 31.5523 40 31 40Z",
    fill: "#FC628F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 18H17C17.5523 18 18 17.5523 18 17C18 16.4477 17.5523 16 17 16H3C2.44772 16 2 16.4477 2 17C2 17.5523 2.44772 18 3 18Z",
    fill: "#FC628F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 26H15C15.5523 26 16 25.5523 16 25C16 24.4477 15.5523 24 15 24H3C2.44772 24 2 24.4477 2 25C2 25.5523 2.44772 26 3 26Z",
    fill: "#FC628F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 34H17C17.5523 34 18 33.5523 18 33C18 32.4477 17.5523 32 17 32H3C2.44772 32 2 32.4477 2 33C2 33.5523 2.44772 34 3 34Z",
    fill: "#FC628F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4515 32.0372L47.7071 40.293C48.0947 40.684 48.0932 41.3148 47.7038 41.7041C47.3145 42.0934 46.6837 42.0946 46.2927 41.707L38.0373 33.4512C33.5152 37.2167 26.8312 36.7595 22.864 32.4133C18.8967 28.0671 19.0495 21.3692 23.2109 17.2084C27.3722 13.0477 34.0701 12.8958 38.4158 16.8637C42.7614 20.8315 43.2177 27.5156 39.4515 32.0372ZM21.9999 25C21.9999 29.9705 26.0294 34 30.9999 34C35.9682 33.9945 39.9944 29.9683 39.9999 25C39.9999 20.0294 35.9705 16 30.9999 16C26.0294 16 21.9999 20.0294 21.9999 25Z",
    fill: "#FC628F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPreview);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/preview.39508a03479d8faedafbeac6b9e89ea0.svg";